let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fbCyW")).then(() => parcelRequire('1DwoI'));